import { render } from "./ArticlesHome.vue?vue&type=template&id=46dacf7c&scoped=true"
import script from "./ArticlesHome.vue?vue&type=script&lang=js"
export * from "./ArticlesHome.vue?vue&type=script&lang=js"

import "./ArticlesHome.vue?vue&type=style&index=0&id=46dacf7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46dacf7c"]])

export default __exports__